import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";

const VideoSkeleton = () => {
  return (
    <Box className="goal-video-outter" style={{ padding: "20px 0 20px 30px" }}>
      <Box className="goal-video-wrapper">
        <Box className="video-wrapper ">
          <Skeleton
            animation="wave"
            variant="rectangular"
            sx={{
              height: "80px",
              width: "135px",
            }}
          />
        </Box>
        <Box className="goal-info-wrapper">
          <Skeleton animation="wave" variant="h2" />
          <Skeleton
            animation="wave"
            variant="body1"
            sx={{ marginTop: "10px" }}
          />
        </Box>
        <Box className="goal-votes-wrapper">
          <Skeleton
            animation="wave"
            variant="circular"
            width={44}
            height={44}
          />
          <Box className="votes-wrapper">
            <Skeleton
              animation="wave"
              variant="circular"
              width={20}
              height={20}
            />
            <Skeleton
              animation="wave"
              variant="body1"
              sx={{ marginTop: "10px" }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default VideoSkeleton;
